import client from "./client";
import { Document } from "@/interfaces";

export const getDocuments = () => client.get<Document[]>("documents");
export const createDocument = (document: Document, onUploadProgress: (progressEvent: ProgressEvent) => void) =>
  client.post<any>("documents", { ...document }, onUploadProgress);
export const updateDocument = (document: Document, onUploadProgress: (progressEvent: ProgressEvent) => void) =>
  client.put<any>(`documents/${document.id}`, { ...document }, onUploadProgress);
export const updateDocumentOrder = (documents: Document[]) =>
  client.post<any>("documents/updateOrder", { list: documents });
export const deleteDocument = (id: number) => client.delete<any>(`documents/${id}`);
